<div class="row">
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">OVERVIEW</h2>
        <table class="table table-borderless definitions w-100">
            <tbody>
            @if (keip.keip_status.length > 1) {
                <tr>
                    <td>Status</td>
                    <td class="ps-2">{{ keip.keip_status}}</td>
                </tr>
            }
            @if (keip.total_participant_count > 0) {
                <tr>
                    <td>Total Participant</td>
                    <td class="ps-2">{{ keip.total_participant_count}}</td>
                </tr>
            }
            @if (keip.keip_payment_minimum_amount.length > 1) {
                <tr>
                    <td>KEIP Payment Threshold Amount</td>
                    <td class="ps-2">{{ keip.keip_payment_minimum_amount}}</td>
                </tr>
            }
            @if (keip.keip_payment_maximum_amount.length > 1) {
                <tr>
                    <td>KEIP Payment Maximum Amount</td>
                    <td class="ps-2">{{ keip.keip_payment_maximum_amount}}</td>
                </tr>
            }
            @if (keip.average_max_individual_keip.length > 1) {
                <tr>
                    <td>Average Max Individual KEIP</td>
                    <td class="ps-2">{{ keip.average_max_individual_keip}}</td>
                </tr>
            }
            @if (keip.maximum_individual_keip.length > 1 && keip.minimum_individual_keip.length > 1) {
                <tr>
                    <td>Max Individual KEIP Range</td>
                    <td class="ps-2">{{ keip.minimum_individual_keip}} - {{ keip.maximum_individual_keip}}</td>
                </tr>
            }
            @if (keip.average_percentage_annual_salary.length > 1) {
                <tr>
                    <td>Average % of Annual Salary</td>
                    <td class="ps-2">{{ keip.average_percentage_annual_salary}}%</td>
                </tr>
            }
            @if (keip.maximum_percentage_annual_salary.length > 1 && keip.minimum_percentage_annual_salary.length > 1) {
                <tr>
                    <td>% of Annual Salary Range</td>
                    <td class="ps-2">{{ keip.minimum_percentage_annual_salary}}% - {{ keip.maximum_percentage_annual_salary}}%</td>
                </tr>
            }
            @if (keip.withdrawn.length > 1) {
                <tr>
                    <td>Withdrawn?
                    </td>
                    <td class="ps-2">{{ keip.withdrawn}}</td>
                </tr>
            }
            </tbody>
        </table>

    </div>
    @if (keip.financial_advisor_restructuring_advisor && keip.financial_advisor_restructuring_advisor.length) {
        <div class="col-xl-6 col-xxl-4 my-2">
            <h2 class="column-header">COMPENSATION CONSULTANT</h2>
            <table class="table table-borderless definitions w-100">
                <thead></thead>
                <tbody>
                    @for (advisorFA of keip.financial_advisor_restructuring_advisor; track advisorFA) {
                    <tr>
                        <td>
                            <a href="/organizations/{{advisorFA.entity_id}}" class="mt-1">{{advisorFA.entity_name}}</a>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    }
    @if (keip.keip_timeline && keip.keip_timeline.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">TIMELINE</h2>
        <table class="table table-borderless definitions w-100">
            @for (timepoint of keip.keip_timeline; track timepoint) {

            <tr>
                <td>
                    {{ timepoint.type }}
                    @if (timepoint.description.length > 5) {
                    ({{ timepoint.description | stripTags }})
                    }
                </td>
                <td class="ps-2">{{ timepoint.date_of_timeline_display}}</td>
            </tr>

            }
        </table>
    </div>
    }
    
    @if (keip.funding_source && keip.funding_source.length && keip.funding_source!="Not Found") {
        <div class="col-xl-6 col-xxl-4 my-2">
            <h2 class="column-header">FUNDING SOURCE</h2>
            <table class="table table-borderless definitions w-100">
                @for (fundingsource of keip.funding_source; track fundingsource) {
                <tr>
                    <td class="ps-2">&bull; {{ fundingsource}}</td>
                </tr>

                }
            </table>
        </div>
    }
    @if (keip.participant_role_type && keip.participant_role_type.length) {
        <div class="col-xl-6 col-xxl-4 my-2">
            <h2 class="column-header">PARTICIPANT ROLE TYPE</h2>
            <table class="table table-borderless definitions w-100">
                @for (participantrole of keip.participant_role_type; track participantrole) {
                <tr>
                    <td class="ps-2">&bull; {{ participantrole}}</td>
                </tr>
                }
            </table>
        </div>
    }
    @if (keip.payout_targets && keip.payout_targets.length > 1 && keip.payout_targets!="Not Found") {
        <div class="col-xl-6 col-xxl-4 my-2">
            <h2 class="column-header">PAYOUT TARGETS</h2>
            <table class="table table-borderless definitions w-100">

                <tr>
                    <td>Targets:</td>
                    <td class="ps-2">
                        @for (payouttarget of keip.payout_targets; track payouttarget) {
                            &bull; {{ payouttarget}}<br/>
                        }
                    </td>
                </tr>
                @if (keip.payout_targets_note.length > 1) {
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                        <td>Notes:</td>
                        <td class="ps-2" [innerHTML]="keip.payout_targets_note"></td>
                    </tr>
                }
            </table>
        </div>
    }

    @if (keip.keip_vesting_termination_condition.length > 1) {
        <div class="col-xl-6 col-xxl-4 my-2">
            <h2 class="column-header">KEIP VESTING AND TERMINATION CONDITION</h2>
            <table class="table table-borderless definitions w-100">
                <tr>
                    <td></td>
                    <td class="ps-2" [innerHTML]="keip.keip_vesting_termination_condition"></td>
                </tr>
            </table>
        </div>
    }
    @if (keip.allow_keip_reallocation.length > 1 && keip.allow_keip_reallocation!="Not Found") {
        <div class="col-xl-6 col-xxl-4 my-2">
            <h2 class="column-header">KEIP REALLOCATION</h2>
            <table class="table table-borderless definitions w-100">
                <tr>
                    <td>Allow KEIP Reallocation?</td>
                    <td class="text-end">{{ keip.allow_keip_reallocation}}</td>
                </tr>
                @if (keip.reallocation_note.length > 1) {
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                        <td>Notes:</td>
                        <td class="ps-2" [innerHTML]="keip.reallocation_note"></td>
                    </tr>
                }
            </table>
        </div>
    }

    @if (keip.clawback_reason && keip.clawback_reason.length && keip.clawback_reason!="Not Found") {
        <div class="col-xl-6 col-xxl-4 my-2">
            <h2 class="column-header">KEIP CLAWBACK REASONS</h2>
            <table class="table table-borderless definitions w-100">

                <tr>
                    <td>Reasons:</td>
                    <td class="ps-2">
                        @for (clawback of keip.clawback_reason; track clawback) {
                            &bull; {{ clawback}}<br/>
                        }
                    </td>
                </tr>
                @if (keip.clawback_note.length > 1) {
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                        <td>Notes:</td>
                        <td class="ps-2" [innerHTML]="keip.clawback_note"></td>
                    </tr>
                }
            </table>
        </div>
    }

    @if (keip.keip_notes && keip.keip_notes.length > 5) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">KEIP NOTES</h2>
        <div [innerHTML]="keip.keip_notes"></div>
    </div>
    }
    <court-documents [documents]="keip.court_documents" colsDefn="col-12"></court-documents>
</div>